import React from 'react'
import { CustomerFreelancerLinkRouteImport } from './Import'
const { RoutesMap, CustomerFreelancerLinkList, AddCustomerFreelancerLink, CustomerFreelancerLinkDetails } = CustomerFreelancerLinkRouteImport

const CustomerFreelancerLinkRoute = () => {
    return [
        {
            path: RoutesMap.CUSTOMER_FREELANCER_LINK_LIST.path,
            element: <CustomerFreelancerLinkList />
        },
        {
            path: RoutesMap.ADD_CUSTOMER_FREELANCER_LINK.path,
            element: <AddCustomerFreelancerLink />
        },
        {
            path: RoutesMap.CUSTOMER_FREELANCER_LINK_DETAILS.path,
            element: <CustomerFreelancerLinkDetails />
        },
    ]
}

export default CustomerFreelancerLinkRoute;
